import { forwardRef, TextareaHTMLAttributes } from 'react';

import { cn } from '@/utils/app.utils';

export interface ITextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, ITextareaProps>(
  ({ className, error, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-800 placeholder:dark:text-neutral-500',
        className,
        error &&
        'border-error placeholder:text-error dark:border-error-dark dark:placeholder:text-error-dark'
      )}
      {...props}
    />
  )
);

Textarea.displayName = 'Textarea';

export { Textarea };
